import { render, staticRenderFns } from "./PerformanceByChannel.vue?vue&type=template&id=255debce&scoped=true&"
import script from "./PerformanceByChannel.vue?vue&type=script&lang=js&"
export * from "./PerformanceByChannel.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceByChannel.vue?vue&type=style&index=0&id=255debce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255debce",
  null
  
)

export default component.exports